import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CategoryStorageType } from '../../../types';
import { Logger } from '../logger';
import { COOKIE_CACHE_URL_PROD, LEGACY_COOKIE_CACHE_URL_PROD, LOCAL_STORAGE_CACHE_URL_PROD, SESSION_STORAGE_CACHE_URL_PROD } from './constants';
export var CacheLoader = /*#__PURE__*/function () {
  /**
   * Cache variable for storing categorized cookies cache
   */

  /**
   * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
   *
   * Allows for many invocations to happen simultaneously, and for only one fetch to go out
   */

  /**
   * Cache variable for storing the promise returned from the response object's json method
   *
   * Ensures we don't invoke response.json multiple times
   */

  function CacheLoader(storageType) {
    _classCallCheck(this, CacheLoader);
    switch (storageType) {
      case CategoryStorageType.Cookies:
        this.cacheUrl = COOKIE_CACHE_URL_PROD;
        break;
      case CategoryStorageType.LocalStorage:
        this.cacheUrl = LOCAL_STORAGE_CACHE_URL_PROD;
        break;
      case CategoryStorageType.SessionStorage:
        this.cacheUrl = SESSION_STORAGE_CACHE_URL_PROD;
        break;
      default:
        this.cacheUrl = LEGACY_COOKIE_CACHE_URL_PROD;
    }
  }
  return _createClass(CacheLoader, [{
    key: "clearStorageControlsDataCache",
    value: function clearStorageControlsDataCache() {
      this.localResponseCache = undefined;
      this.localResponsePromiseCache = undefined;
      this.localResponseJsonPromiseCache = undefined;
    }

    /**
     * Unpacks the response promise from the categories CDN
     *
     * errors if that request was unsuccessful, returns the categories data otherwise
     *
     */
  }, {
    key: "handleCategoriesResponse",
    value: (function () {
      var _handleCategoriesResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(responsePromise) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (responsePromise) {
                _context.next = 2;
                break;
              }
              throw new Error("Failed to fetch Cookies Cache! Cached promise was undefined");
            case 2:
              _context.next = 4;
              return responsePromise;
            case 4:
              response = _context.sent;
              if (response.ok) {
                _context.next = 7;
                break;
              }
              throw new Error("Failed to fetch Cookies Cache! status: ".concat(response.status));
            case 7:
              // Checks if we've already fired the response.json() promise
              this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
              return _context.abrupt("return", this.localResponseJsonPromiseCache);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleCategoriesResponse(_x) {
        return _handleCategoriesResponse.apply(this, arguments);
      }
      return handleCategoriesResponse;
    }())
  }, {
    key: "loadStorageControlsData",
    value: function () {
      var _loadStorageControlsData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.localResponseCache) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", this.localResponseCache);
            case 4:
              _context2.prev = 4;
              if (!this.localResponsePromiseCache) {
                Logger.debug("Loading cache ".concat(this.cacheUrl));
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
              }

              // unpack response
              _context2.next = 8;
              return this.handleCategoriesResponse(this.localResponsePromiseCache);
            case 8:
              this.localResponseCache = _context2.sent;
              return _context2.abrupt("return", this.localResponseCache);
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](4);
              Logger.errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: _context2.t0.message || ''
              });
              this.clearStorageControlsDataCache();
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 12]]);
      }));
      function loadStorageControlsData() {
        return _loadStorageControlsData.apply(this, arguments);
      }
      return loadStorageControlsData;
    }()
  }]);
}();
export { LEGACY_COOKIE_CACHE_URL_PROD, COOKIE_CACHE_URL_PROD, LOCAL_STORAGE_CACHE_URL_PROD, SESSION_STORAGE_CACHE_URL_PROD } from './constants';